var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    color: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.508 2.99c-4.483 0-6.724 0-8.117 1.392C2 5.774 2 8.015 2 12.496s0 6.722 1.392 8.114c1.393 1.392 3.634 1.392 8.117 1.392s6.724 0 8.117-1.392c1.392-1.392 1.392-3.633 1.392-8.114v-.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.999 20.99c4.21-4.752 8.94-11.053 16-6.327M17.996 1.998v8.008M22 5.977l-8.01.015"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddImage);
export default __webpack_public_path__ + "static/media/add-image.e582e2c5545359eaee18d8456c1e7d4a.svg";
export { ForwardRef as ReactComponent };